import { create } from "zustand";

export type AuthStep = "email" | "otp" | "profile";

interface AuthModalState {
  isOpen: boolean;
  step: AuthStep;
  email: string;
  isNewUser: boolean;
  message?: string;
  // Keep backward-compat aliases
  mode: "login" | "signup";
  open: (message?: string) => void;
  openLogin: (message?: string) => void;
  openSignup: (message?: string) => void;
  close: () => void;
  setStep: (step: AuthStep) => void;
  setEmail: (email: string) => void;
  setIsNewUser: (isNewUser: boolean) => void;
}

export const useAuthModal = create<AuthModalState>((set) => ({
  isOpen: false,
  step: "email",
  email: "",
  isNewUser: false,
  mode: "login",
  message: undefined,
  open: (message) => set({ isOpen: true, step: "email", email: "", isNewUser: false, message }),
  openLogin: (message) =>
    set({ isOpen: true, step: "email", email: "", isNewUser: false, mode: "login", message }),
  openSignup: (message) =>
    set({ isOpen: true, step: "email", email: "", isNewUser: false, mode: "signup", message }),
  close: () =>
    set({ isOpen: false, step: "email", email: "", isNewUser: false, message: undefined }),
  setStep: (step) => set({ step }),
  setEmail: (email) => set({ email }),
  setIsNewUser: (isNewUser) => set({ isNewUser }),
}));
